import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BaseEntity } from 'yt-ng-framework';

export class ResenjeZaGo extends BaseEntity {
  constructor() {
      super();
  }
  
  OsobaID: number = null;
  PravoNaGoID: number = null;
  Godina: number = null;
  Broj: number = null;
  Datum: NgbDate = null;
  PravoNaGoBrojDana: number = null;
  PodvrstaDokumentaStavkaID: number = null;

  Deserialize(input: any) {
    this.ID = input.ID;
    this.OsobaID = input.OsobaID;
    this.PravoNaGoID = input.PravoNaGoID;
    this.Godina = input.Godina;
    this.Broj = input.Broj;
    this.Datum = input.Datum;
    this.PravoNaGoBrojDana = input.PravoNaGoBrojDana;
    this.PodvrstaDokumentaStavkaID = input.PodvrstaDokumentaStavkaID;
    return this;
  }

  Serialize(input: ResenjeZaGo) {
      return input;
  }
}
